<template>
  <button class="oversized-button" @click.prevent="$emit('click')">
    <v-icon :class="iconClass">
      {{ icon }}
    </v-icon>
    <div class="oversized-button-content">
      <slot>
        <span class="oversized-button-title">{{ text }}</span>
      </slot>
    </div>
  </button>
</template>

<script>
/**
 * @name SlsOptionButton
 * @description
 * A large, clickable option button with an icon and text content.
 */
export default {
  name: 'SlsOptionButton',
  props: {
    /**
     * Main icon
     * @type {String}
     * @required
     */
    icon: {
      required: true,
      type: String,
    },
    /**
     * Main text
     * @type {String}
     */
    text: {
      required: true,
      type: String,
    },
  },
  computed: {
    iconClass() {
      return ['oversized-button-icon', 'ml-3']
    },
  },
}
</script>

<style lang="sass">
.oversized-button
  align-items: center
  background-color: $lightBlue
  border-radius: 10px
  border: 1px solid $lightGrey
  column-gap: 8px
  cursor: pointer
  display: flex
  justify-content: flex-start
  padding: 12px 20px
  transition: background-color 0.2s ease
  width: 100%

  &:hover
    background-color: rgba(0, 0, 0, 0.04)

  &-content
    display: flex
    color: $darkBlue
    flex-direction: column
    font-size: 0.875rem
    text-align: left

  & &-icon
    color: $darkBlue

  &-action
    margin-right: 12px
</style>
